export default function FloatingActions() {
  return null;
}
